export default "__VITE_ASSET__C6HLBt$l__"